import React from 'react';
import DashboardLayout from './DashboardLayout';
import LeaveManagementPanel from './LeaveManagementPanel';

function LeaveManagementPage() {
  return (
    <DashboardLayout title="Leave Management">
      <div className="py-4">
        <LeaveManagementPanel />
      </div>
    </DashboardLayout>
  );
}

export default LeaveManagementPage;
